import { Button } from "@mantine/core";
import { IconDeviceFloppy, IconHistory, IconPlus } from "@tabler/icons-react";
import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useIsOnline } from "src/hooks";
import { ButtonsWrapper } from "src/styled";

interface Props {
  onAdd?: () => void;
  isSaving: boolean;
  canSave?: boolean;
  children?: ReactNode;
  section: string;
}

const YachtSetupSectionHeader = ({
  onAdd,
  isSaving,
  canSave = true,
  children,
  section,
}: Props) => {
  const isOnline = useIsOnline();
  const navigate = useNavigate();

  return (
    <Breadcrumbs>
      <ButtonsWrapper>
        {children}
        {onAdd && canSave && isOnline && (
          <Button
            onClick={onAdd}
            variant="outline"
            leftIcon={<IconPlus size="1.4rem" />}>
            Add
          </Button>
        )}
        <Button
          onClick={() => navigate(`/settings/yacht/history/${section}`)}
          leftIcon={<IconHistory size="1.4rem" />}
          variant="outline">
          History
        </Button>
        {canSave && isOnline && (
          <Button
            type="submit"
            leftIcon={<IconDeviceFloppy size="1.4rem" />}
            variant="outline"
            loading={isSaving}>
            Save
          </Button>
        )}
      </ButtonsWrapper>
    </Breadcrumbs>
  );
};

export default YachtSetupSectionHeader;
